import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingServicedeskSelfServiceSetupRoute: InvariantJiraRoute = {
	name: 'project-setting-servicedesk-self-service-setup',
	path: '/jira/servicedesk/projects/:projectKey/settings/rovo-service-agent/self-service-setup',
	exact: true,
};
